import React, { useState } from "react";
import { Download, Loader, FileText } from "lucide-react";
//import { generateActivityPDF } from "../../../utils/generateActivityPDF";
import { generateActivityPDF } from "../../../utils/ActivityPDFGenerator";
/**
 * Professional PDF export button with actual PDF generation
 */
const ExportPDFButton = ({
  currentFilters,
  hasActiveFilters,
  onLoadAllActivities,
  userProfile, // Need user profile for PDF cover page
}) => {
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async () => {
    try {
      setExporting(true);
      setError(null);

      // Load all activities (filtered or unfiltered)
      const activities = await onLoadAllActivities(currentFilters || {});

      if (!activities || activities.length === 0) {
        setError("No activities to export");
        setExporting(false);
        return;
      }

      // Generate PDF using the actual PDF generator
      await generateActivityPDF(activities, userProfile);

      // Show success state briefly
      setTimeout(() => {
        setExporting(false);
      }, 500);
    } catch (err) {
      console.error("Error exporting PDF:", err);
      setError("Failed to export PDF");
      setExporting(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-2">
      <button
        onClick={handleExport}
        disabled={exporting}
        className={`
          inline-flex items-center gap-2 px-4 py-2.5
          text-sm font-medium rounded-lg
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-offset-2
          ${
            exporting
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500"
          }
        `}
      >
        {exporting ? (
          <>
            <Loader className="w-4 h-4 animate-spin" />
            Exporting...
          </>
        ) : (
          <>
            <Download className="w-4 h-4" />
            Export Activities
          </>
        )}
      </button>

      {/* Helper Text */}
      {hasActiveFilters && !error && !exporting && (
        <p className="text-xs text-gray-500">
          <FileText className="w-3 h-3 inline mr-1" />
          Filtered activities will be exported
        </p>
      )}

      {/* Error Message */}
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default ExportPDFButton;


